// src/components/Landing/HeroSection.js
import React, { useEffect, useRef } from 'react';
import './HeroSection.css';

export function HeroSection() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <section className="hero" ref={sectionRef}>
      <div className="container">
        <div className="hero-inner">
          <div className="hero-text">
            <p className="hero-label reveal">AI-Powered Education</p>
            <h1 className="hero-title reveal reveal-delay-1">
              Master supply chain<br />with your <em>AI tutor</em>
            </h1>
            <p className="hero-desc reveal reveal-delay-2">
              Supply Chain Brutus is an intelligent assistant built for logistics
              and supply chain education. Tailored to your coursework, it makes
              complex concepts accessible and keeps learning engaging.
            </p>
            <a
              href="https://app.supplychainbrutus.com"
              className="hero-cta reveal reveal-delay-3"
              target="_blank"
              rel="noopener noreferrer"
            >
              Start Learning
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7" />
              </svg>
            </a>
          </div>
          <div className="hero-image-wrap reveal reveal-delay-2">
            <div className="hero-image-bg" aria-hidden="true"></div>
            <img
              src="/SupplyChainBrutus.png"
              alt="Supply Chain Brutus - AI Tutor"
              className="brutus-avatar"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
